import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareFacebook, faSquareInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import "./maintenance.scss";

const images = [
    "/images/maintenance/bg01.jpg",
    "/images/maintenance/bg02.jpg",
    "/images/maintenance/bg03.jpg",
];

const Maintenance = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [prevIndex, setPrevIndex] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
        setPrevIndex(currentIndex); // Save old index before updating
        setCurrentIndex((prev) => (prev + 1) % images.length);

        // After 3s, remove prevIndex
        setTimeout(() => {
            setPrevIndex(null);
        }, 3000);
        }, 6000);

        return () => clearInterval(interval);
    }, [currentIndex]);

    return (
        <div className="Maintenance_page">
            <div className="sliding_bg">
                {images.map((item, index) => (
                    <div
                        key={index}
                        className={`${
                            index === currentIndex ? "visible top" : index === prevIndex ? "visible" : ""
                        }`}
                        style={{ backgroundImage: `url(${item})` }}
                    />
                ))}
            </div>
            <div id="header">
                <h1>Page Coming Soon</h1>
                <p>Hang tight! We’re building something awesome to make your experience even better.<br />
                Great things take time, and we can’t wait to share it with you.</p>
                <p>Check back soon — it will be worth it!</p>
            </div>
            <div id="footer">
                <ul className="icons">
                    <li>
                        <a href="https://www.facebook.com/queenboss.societyofficial">
                            <FontAwesomeIcon icon={faSquareFacebook} />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/queenboss.society">
                            <FontAwesomeIcon icon={faSquareInstagram} />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <FontAwesomeIcon icon={faTiktok} />
                        </a>
                    </li>
                </ul>
                <ul className="copyright">
                    <li>&copy; Queen Boss Society</li>
                    <li>King Boss Club</li>
                </ul>
            </div>
        </div>
    );
}

export default Maintenance;
